module.exports = (__webpack_require__(24))(859);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/copy-to-clipboard/index.js from dll-reference lib_core
// module id = 961
// module chunks = 109